// extracted by mini-css-extract-plugin
export default {"container":"legal_bank_details_modal_container__8UUtl","buttonGroup":"legal_bank_details_modal_buttonGroup__8EYiv"};